import { useEffect, useState } from "react";
import { PageHero } from "@/components/PageHero";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Motion";
import { api } from "@/lib/api";

const FILTERS = ["All", "Cookies", "Cupcakes", "Cheesecakes"];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/products")
      .then((r) => setProducts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setError(true));
  }, []);

  const shown = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <main data-testid="shop-page">
      <PageHero eyebrow="The Shop" lines={["Desserts,", <span className="italic text-mocha">made to order.</span>]} intro="Order online for pickup in Clifton Heights, PA. Pickup details are sent once payment is received." />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-28">
        <div className="flex flex-wrap gap-3 border-t border-espresso/15 pt-8 mb-14">
          {FILTERS.map((f) => (
            <button key={f} data-testid={`shop-filter-${f.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setFilter(f)}
              className={`px-6 py-2.5 rounded-full text-[12px] uppercase tracking-[0.2em] border transition-colors duration-300 ${filter === f ? "bg-espresso text-cream border-espresso" : "border-espresso/25 hover:border-espresso"}`}>
              {f}
            </button>
          ))}
        </div>
        {error && <p data-testid="shop-error" className="text-mocha">The menu is taking a moment to load. Please refresh shortly.</p>}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {shown.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <ProductCard p={p} index={i} />
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
